import React from 'react';
import classnames from 'classnames';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import { ServerVarsContextConsumer } from '../../global/ServerVarsContext/ServerVarsContext';
import { trackEcommerce } from 'dibs-tracking';

// components
import { SbSharedLink } from '../SbSharedLink/SbSharedLink';
import { SbRespTilesSwiper } from '../SbRespTilesSwiper/SbRespTilesSwiper';

import { ROOM_TILES } from '../../constants/sbRoomMap';

// styles
import styles from './sbRespRoomTiles.scss';

class SbRespRoomTilesComponent extends React.Component {
    constructor() {
        super();

        this.getRoomsPromotions = this.getRoomsPromotions.bind(this);
    }

    componentDidMount() {
        this.fireTracking();
    }

    fireTracking() {
        trackEcommerce({
            type: 'promotionImpression',
            promotions: this.getRoomsPromotions(),
        });
    }

    trackClick(index) {
        const promotions = this.getRoomsPromotions();
        trackEcommerce({
            type: 'promoClick',
            promotions: [promotions[index]],
        });
    }

    getRoomsPromotions() {
        return ROOM_TILES.map((tile, index) => ({
            id: `L0-Room Tiles`,
            name: `L0|${tile.displayName.defaultMessage}`,
            position: index + 1,
        }));
    }

    render() {
        return (
            <ServerVarsContextConsumer>
                {({ isTablet }) => {
                    const containerClass = classnames(styles.container, {
                        rowFlex: !isTablet,
                    });

                    return (
                        <div className={containerClass}>
                            <SbRespTilesSwiper isTablet={isTablet}>
                                {ROOM_TILES.map((tile, index) => {
                                    const { displayName, url, image } = tile;
                                    const title = this.props.intl.formatMessage(displayName);
                                    const src = `${image}&height=300`;
                                    return (
                                        <SbSharedLink
                                            className={`${styles.roomContainer} colXs3`}
                                            href={url}
                                            key={url}
                                            onClick={() => this.trackClick(index)}
                                        >
                                            <div className={styles.imageWrapper}>
                                                <img
                                                    className={styles.image}
                                                    src={src}
                                                    alt={title}
                                                />
                                                <span className={styles.shop}>
                                                    <FormattedMessage
                                                        id="sb.SbRespRoomTiles.shop"
                                                        defaultMessage="Shop"
                                                    />
                                                </span>
                                            </div>
                                            <div className={styles.title}>{title}</div>
                                        </SbSharedLink>
                                    );
                                })}
                            </SbRespTilesSwiper>
                        </div>
                    );
                }}
            </ServerVarsContextConsumer>
        );
    }
}

SbRespRoomTilesComponent.propTypes = {
    intl: intlShape.isRequired,
};

export const SbRespRoomTiles = injectIntl(SbRespRoomTilesComponent);
